import _extends from "@babel/runtime/helpers/extends";
import { logErrorType, logEventType, logWarningType } from '../trackerTypes.js';
const searchKeywordKey = 'searchterm';

function getSearchKeyword(searchParams) {
  let params = searchParams;

  if (!params) {
    params = new URLSearchParams(window.location.search);
  }

  return params.get(searchKeywordKey);
}

export default function ThdCanadaPayload(data, navigationData = {}) {
  const _navigationData$navig = navigationData.navigationBlock,
        navigationBlock = _navigationData$navig === void 0 ? {} : _navigationData$navig;
  let search = navigationData.search; // Get the keyword from the query string if it doesn't exist already

  if (!search) {
    search = {
      keyword: getSearchKeyword(),
      redirect: true
    };
  }

  if (!search.keyword) {
    search.keyword = getSearchKeyword();
  }

  return _extends({}, data, {
    navigationBlock,
    search
  });
} // Mapping for the proper Canada event types and error types

const caEvtTypes = {
  [logEventType.error]: 'Site Error',
  [logEventType.warning]: 'Site Warning',
  [logEventType.information]: 'Site Information'
};
const caErrorTypes = {
  [logErrorType.server]: 'serverError',
  [logErrorType.input]: 'inputError',
  [logErrorType.form]: 'formError'
};
const caWarningTypes = {
  [logWarningType.warning]: 'warningMessage'
};
/**
 * @param {import('../trackerTypes.js').LogInfo} logInfo
 */

export function ThdCanadaLogData(logInfo, eventType) {
  const errorTypes = eventType === logEventType.error ? caErrorTypes : caWarningTypes;
  return {
    event: {
      type: caEvtTypes[eventType]
    },
    payload: {
      [eventType]: {
        type: errorTypes[logInfo.type],
        userInformed: logInfo.userInformed,
        code: logInfo.code,
        value: logInfo.description,
        target: logInfo.target,
        payload: logInfo.payload
      }
    }
  };
}